import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd001-card-limpeza-II',
    templateUrl: './cd001-card-limpeza-II.component.html'
})

export class Cd001CardLimpezaIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
    public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;
    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Medição de Vazão do Processo', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                peso_amostra_dez_segundos_kg: [null, []],
                vazao_processo_th: [null, []],
            });
        }
        else {
            this.formulario = this.formBuilder.group({
                peso_amostra_cinco_segundos_kg: [null, []],
                vazao_processo_th: [null, []],
            });
        }

    }

    public async ngOnInit(): Promise<void> {
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}
